import creator from '@utils/creator.js';
import 'vite/modulepreload-polyfill';

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/native-loading/ls.native-loading';

import {revive} from '@script/lib/revive.js';
import {
	HeartWishlist,
	ListingWishlist,
	ShareWishlist,
} from '@colorz-packages/sendwish-front';

import TextExpand from '@components/TextExpand';
import ExpandableMobile from '../colorz/core/ExpandableMobile';

import SliderNoDefer from '@components/ClrzSliderNoDefer';
import Expandable from '@components/Expandable';

import CardProduct from '@components/CardProduct';
import Newsletter from '@components/Newsletter';
import AnnouncementBar from '@components/AnnouncementBar';
import Timeline from '@components/Timeline';
import Anchor from '../colorz/core/Anchor';
import '../lib/iovation-loader-5.x.js';

import BookmarkButton from '@components/BookmarkButton';
import TruncateHtml from '@components/TruncateHtml';

import WishlistReview from '@components/WishlistReview.js';
import ProductStarsReview from '@components/ProductStarsReview.js';

import TabIndexMobile from '@components/TabIndexMobile.js';
import SubscriptionFormPlus from '@components/SubscriptionFormPlus';
import FormRegister from '@components/FormRegister.js';

import ValidationForm from '@components/ValidationForm.js';

import AnnouncementTimer from '@components/Timer.js';
import CartBenefitsGauge from '@components/CartBenefitsGauge.js';

lazySizes.cfg.lazyClass = 'lazyload';
lazySizes.cfg.init = true;
lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.loadMode = 1;
lazySizes.cfg.nativeLoading = {
	setLoadingAttribute: true,
	disableListeners: {
		focus: false,
		mouseover: false,
		click: false,
		load: false,
		transitionend: false,
		animationend: false,
		scroll: true,
		resize: true,
	},
};

import Header from '@components/Header';
import Tabs from '@components/Tabs';
import HistoricalsProduct from '@components/HistoricalsProducts';

window.ClrzApp = {};

function ClrzAppInit() {
	ClrzApp.Header = creator('.js-header', Header);
	ClrzApp.TextExpand = creator('.js-text-expand', TextExpand);
	ClrzApp.ExpandableMobile = creator('.js-expandable-mobile', ExpandableMobile);
	customElements.define('clrz-slider-no-defer', SliderNoDefer);
	ClrzApp.Expandable = creator('.js-expandable', Expandable);
	customElements.define('card-product', CardProduct);
	ClrzApp.Newsletter = creator('.js-newsletter', Newsletter);
	ClrzApp.AnnouncementBar = creator('.js-announcement-bar', AnnouncementBar);
	ClrzApp.Tabs = creator('.js-tabs', Tabs);
	ClrzApp.Timeline = creator('.js-timeline', Timeline);
	ClrzApp.Anchor = creator('.js-anchor', Anchor);
	ClrzApp.BookmarkButton = creator('.js-bookmark-button', BookmarkButton);

	customElements.define('product-stars-review', ProductStarsReview);
	customElements.define('wishlist-review', WishlistReview);
	ClrzApp.TruncateHtml = creator('.js-truncate-html', TruncateHtml);
	ClrzApp.TabIndexMobile = creator('.js-tab-index-mobile', TabIndexMobile);
	customElements.define('subscription-form-plus', SubscriptionFormPlus);
	ClrzApp.FormRegister = creator('.js-form-register', FormRegister);

	ClrzApp.ValidationForm = creator('.js-validation-form', ValidationForm);

	ClrzApp.HistoricalsProduct = creator(
		'.js-historical-products',
		HistoricalsProduct,
	);
	ClrzApp.AnnouncementTimer = creator(
		'.js-announcement-timer',
		AnnouncementTimer,
	);
	customElements.define('cart-benefits-gauge', CartBenefitsGauge);
}

ClrzAppInit();

export const islands = import.meta.glob('../islands/*.js');

for (let island in islands) {
	revive(island, islands);
}

document.addEventListener('product-recommendations-render', function () {
	ClrzApp.CardProduct = creator('.js-card-product', CardProduct);
});

document.addEventListener('update-cart-render', function () {
	ClrzApp.Expandable = creator('.js-expandable', Expandable);
});
